export const widgetConfig = {
    hotelId: 'lesdunes',
    ticker: 'dunes_comodoro',
    engine: 'witbooking',
    showPrice: false,
    defaultAdults: 2,
    defaultChildren: 0,
    currency: 'EUR',
    baseUrl: 'https://reservations.lesdunes.es/',
    urlChain: 'hotel',
    urlHotel: 'hotel',
    showChildAges: true,
    noOnDesktop: false,
    type: 'hotel',
    maxRooms: '5',
    showAllHotelsOption: 'false',
    showHotelSelector: false,
    targetBlank: true,
};
